import React, { PureComponent } from 'react';
import { injectGlobal } from 'styled-components';

export default class HideBranchJourney extends PureComponent {
    render() {
        return (<span data-test="hide-branch-journey" />);
    }

    componentDidMount() {
        injectGlobal`
            body.hide-branch-journey .branch-animation {
                display: none;
            }
        `;
        document.body.classList.add('hide-branch-journey');
    }

    componentWillUnmount() {
        document.body.classList.remove('hide-branch-journey');
    }
}
